// Corporate program details data - separated to avoid babel plugin issues
export const programDetails = {
  1: {
    summary: 'Our Security Awareness Training program is fully demo- and practical-driven, using visual reinforcement to teach people how real attacks and frauds actually happen. The hands-on approach has earned strong, positive feedback from our customers.',
    topics: [
      'Phishing Recognition',
      'AI Attacks Recognition',
      'Social Engineering',
      'Threats of Vulnerable Softwares',
      'Password Security',
      'Data Protection',
      'Physical Security',
      'Incident Reporting',
      'Cyber Attack Readiness Framework',
      'Personal Frauds',
      'Protection from scammers'
    ],
    suitableFor: [
      'All employees',
      'New hires',
      'Remote workers',
      'Customer-facing staff'
    ],
    benefits: [
      'Reduced human risk factor',
      'Compliance readiness',
      'Measurable improvement',
      'Custom branded content',
      'Ongoing reinforcement'
    ],
    trainer: 'Dhruv Shah',
    trainerBio: 'Security awareness specialist with 15+ years experience in enterprise training.',
  },
  2: {
    summary: 'Intensive hands-on training for your technical teams. We cover both offensive and defensive techniques to build well-rounded security professionals.',
    topics: [
      'Vulnerability Assessment',
      'Penetration Testing Basics',
      'Secure Code Review',
      'Incident Detection',
      'Log Analysis',
      'Threat Hunting'
    ],
    suitableFor: [
      'IT security teams',
      'System administrators',
      'Developers',
      'DevOps engineers'
    ],
    benefits: [
      'Practical skills development',
      'Real-world scenarios',
      'Tool proficiency',
      'Team building',
      'Certification prep'
    ],
    trainer: 'Victor Reyes',
    trainerBio: '15+ years in offensive security. Former red team lead at Fortune 500 companies.',
  },
  3: {
    summary: 'Strategic security briefings for leadership. We translate technical risks into business impact and provide actionable governance recommendations.',
    topics: [
      'Threat Landscape Overview',
      'Risk Assessment',
      'Compliance Requirements',
      'Security Investment ROI',
      'Board Reporting',
      'Crisis Communication'
    ],
    suitableFor: [
      'C-suite executives',
      'Board members',
      'Department heads',
      'Risk committee'
    ],
    benefits: [
      'Informed decision making',
      'Risk visibility',
      'Compliance confidence',
      'Strategic alignment',
      'Stakeholder communication'
    ],
    trainer: 'Marcus Thompson',
    trainerBio: 'CISO consultant with experience advising Fortune 100 boards on cybersecurity strategy.',
  },
  4: {
    summary: 'Test your incident response capabilities with realistic tabletop exercises. We simulate real-world scenarios to identify gaps and improve coordination.',
    topics: [
      'Scenario Development',
      'Role-Based Exercises',
      'Communication Testing',
      'Decision Making',
      'Gap Analysis',
      'Improvement Planning'
    ],
    suitableFor: [
      'IR teams',
      'IT leadership',
      'Legal/PR teams',
      'Executive sponsors'
    ],
    benefits: [
      'Identify response gaps',
      'Improve coordination',
      'Test playbooks',
      'Build confidence',
      'Compliance evidence'
    ],
    trainer: 'Elena Kozlov',
    trainerBio: 'Former incident commander with experience handling major breaches at global organizations.',
  },
  5: {
    summary: 'A hands-on course focused on uncovering and exploiting weaknesses in AI-enabled applications, developer tools, and browser-based copilots, with practical defenses teams can deploy immediately.',
    topics: [
      'Prompt Injection Techniques',
      'Data Exfiltration via LLMs',
      'Tool and Agent Abuse',
      'Model Supply-Chain Risks',
      'Browser and IDE Plugin Threats',
      'Guardrails and Detection',
      'Red Teaming AI Systems'
    ],
    suitableFor: [
      'Security engineers',
      'AI product teams',
      'Application security teams',
      'Red team members'
    ],
    benefits: [
      'Understand AI-specific attack paths',
      'Hands-on attacker mindset',
      'Actionable defense patterns',
      'Safer AI feature rollouts',
      'Improved risk assessments'
    ],
    trainer: 'Sonia Patel',
    trainerBio: 'AI security researcher with 10+ years in appsec and ML security assessments.',
  },
  6: {
    summary: 'A practical secure code review program that trains engineers to identify real vulnerabilities, reason about impact, and apply fixes with confidence.',
    topics: [
      'Threat Modeling for Review',
      'Code Smell Triage',
      'OWASP Top 10 in Practice',
      'Auth and Access Control Flaws',
      'Injection and Deserialization',
      'Secure Remediation Patterns',
      'Review Automation Workflows'
    ],
    suitableFor: [
      'Software engineers',
      'Security champions',
      'AppSec teams',
      'Tech leads'
    ],
    benefits: [
      'Fewer vulnerabilities in production',
      'Faster, higher-quality reviews',
      'Shared security language',
      'Reusable review checklists',
      'Better collaboration with AppSec'
    ],
    trainer: 'Miguel Alvarez',
    trainerBio: 'Lead application security engineer specializing in code review and developer enablement.',
  },
  7: {
    summary: 'A hands-on threat hunting program that builds repeatable hunting workflows using Sigma, SPL, and KQL with real-world datasets and scenarios.',
    topics: [
      'Hunt Hypothesis Development',
      'Sigma Rule Authoring',
      'SPL Query Crafting',
      'KQL Fundamentals',
      'Behavioral Analytics',
      'Triage and Enrichment',
      'Operationalizing Hunts'
    ],
    suitableFor: [
      'SOC analysts',
      'Threat hunters',
      'Blue team engineers',
      'Detection engineers'
    ],
    benefits: [
      'Repeatable hunting playbooks',
      'Stronger detection coverage',
      'Reduced alert fatigue',
      'Faster investigation cycles',
      'Improved attacker visibility'
    ],
    trainer: 'Alyssa Chen',
    trainerBio: 'Threat hunting lead with experience building detection programs for global enterprises.',
  },
};
